
/**
 * 콘텐츠 타입
 */
export type CourseDraftCreateLocalizedSectionsItemLecturesItemContentType = typeof CourseDraftCreateLocalizedSectionsItemLecturesItemContentType[keyof typeof CourseDraftCreateLocalizedSectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDraftCreateLocalizedSectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  INTERACTIVE: 'INTERACTIVE',
  QUIZ: 'QUIZ',
} as const;
